import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'

import Login from './views/Login'
import Projects from './views/Projects'
import Home from './views/Home'
// import Reports from './views/Reports'

Vue.use(Router)

let router = new Router({
// export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: {
        name: 'Login'
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/projects',
      name: 'Proyectos',
      component: Projects,
      meta: {
        requiresAuth: true
      }
    },

    // Gestion
    // Personal
    {
      path: '/manage/staff',
      name: 'Gestión de Personal',
      component: () => import('./views/Manage/Staff'),
      meta: {
        requiresAuth: true
      }
    },
    // Projectos
    {
      path: '/manage/projects',
      name: 'Gestión de proyectos',
      component: () => import('./views/Manage/Projects'),
      meta: {
        requiresAuth: true
      }
    },
    // Operativos del Proyecto
    {
      path: '/manage/projectoperation',
      name: 'Gestión de Grupos Operacionales',
      component: () => import('./views/Manage/ProjectOperation'),
      meta: {
        requiresAuth: true
      }
    },
    // Grupos del Operativo
    {
      path: '/manage/groups',
      name: 'Gestión de Grupos',
      component: () => import('./views/Manage/Groups'),
      meta: {
        requiresAuth: true
      }
    },
    // Personal del Proyectos
    {
      path: '/manage/projectstaff',
      name: 'Gestión de Personal del Proyecto',
      component: () => import('./views/Manage/ProjectStaff'),
      meta: {
        requiresAuth: true
      }
    },

    // Conexión Lime Survey
    {
      path: '/integration/LimeSurvey',
      name: 'Lime Survey',
      component: () => import('./views/Manage/LimeSurvey'),
      meta: {
        requiresAuth: true
      }
    },
    // Conexión Lime Survey
    {
      path: '/integration/Forms',
      name: 'Formularios',
      component: () => import('./views/Integration/Forms'),
      meta: {
        requiresAuth: true
      }
    },
    // ECA
    {
      path: '/eca/table',
      name: 'Relacion de cajas y carpetas por cedula',
      component: () => import('./views/EspecificReports/ECA/General'),
      meta: {
        requiresAuth: true
      }
    },
    // IECA
    {
      path: '/eca/fuid',
      name: 'FUID',
      component: () => import('./views/EspecificReports/ECA/fuid'),
      meta: {
        requiresAuth: true
      }
    },

    // REPORTE OSDIAL
    {
      path: '/osdial/bidosdial',
      name: 'Reporte Osidal',
      component: () => import('./views/EspecificReports/OSDIAL/BidOsdial'),
      meta: {
        requiresAuth: true
      }
    },

    // {
    //   path: '/reports',
    //   name: 'Reports',
    //   component: Reports,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // },

    // Reportes Generales
    {
      path: '/report/dashboardoperational',
      name: 'Dashboard',
      component: () => import('./views/GeneralReports/DashboardOper'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/report/progress',
      name: 'Reporte de Avance',
      component: () => import('./views/GeneralReports/Progress'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/report/multiple',
      name: 'Reporte Multiple',
      component: () => import('./views/GeneralReports/Multiple'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/report/pollster',
      name: 'Reporte de Encuestador',
      component: () => import('./views/GeneralReports/Pollster'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/report/validaterecords',
      name: 'Validar Audios',
      component: () => import('./views/GeneralReports/ValidateRecords'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/report/mapleaflet',
      name: 'MapLeaflet',
      component: () => import('./views/GeneralReports/MapLeaflet'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/report/audioreport',
      name: 'Reporte Audios Callcenter',
      component: () => import('./views/GeneralReports/AudioReport'),
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/report/records',
    //   name: 'Audios',
    //   component: () => import('./views/GeneralReports/Records'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },

    // iK
    {
      path: '/ik/restrooms',
      name: 'Aseo de los baños',
      component: () => import('./views/EspecificReports/iK/Restrooms'),
      meta: {
        requiresAuth: true
      }
    },

    // CCB
    {
      path: '/ccb/tables',
      name: 'Reportes',
      component: () => import('./views/EspecificReports/CCB/Tables'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/bid/table',
      name: 'Dedicacion a proyectos',
      component: () => import('./views/EspecificReports/BID/Bid_tb1'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ccb/incidents',
      name: 'Incidencias',
      component: () => import('./views/EspecificReports/CCB/Incidents'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ccb/representativeness',
      name: 'Representatividad',
      component: () => import('./views/EspecificReports/CCB/Representativeness'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ccb/records',
      name: 'CCB Audios',
      component: () => import('./views/EspecificReports/CCB/Records'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ccb/images',
      name: 'Imágenes',
      component: () => import('./views/EspecificReports/CCB/Images'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ccb/validateaddress',
      name: 'Validar Direcciones',
      component: () => import('./views/EspecificReports/CCB/ValidateAddress'),
      meta: {
        requiresAuth: true
      }
    },

    // SemCali
    {
      path: '/semcali/actor',
      name: 'Actor',
      component: () => import('./views/EspecificReports/SemCali/Actor'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/semcali/institute',
      name: 'Institución',
      component: () => import('./views/EspecificReports/SemCali/Institute'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/semcali/project',
      name: 'Proyecto',
      component: () => import('./views/EspecificReports/SemCali/Project'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/semcali/instituteproject',
      name: 'Institución vs Proyecto',
      component: () => import('./views/EspecificReports/SemCali/InstituteProject'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/semcali/instituteprojectactor',
      name: 'Institución vs Proyecto vs Actor',
      component: () => import('./views/EspecificReports/SemCali/InstituteProjectActor'),
      meta: {
        requiresAuth: true
      }
    },

    // BID
    {
      path: '/bid/graphics',
      name: 'Graficas',
      component: () => import('./views/EspecificReports/BID/Graphics'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/bid/tables',
      name: 'Tablas',
      component: () => import('./views/EspecificReports/BID/Tables'),
      meta: {
        requiresAuth: true
      }
    },

    // ARN
    {
      path: '/arn/graphics',
      name: 'Graficas',
      component: () => import('./views/EspecificReports/ARN/Graphics'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/arn/table',
      name: 'Territorial',
      component: () => import('./views/EspecificReports/ARN/Territorial'),
      meta: {
        requiresAuth: true
      }
    },

    // SSPD
    {
      path: '/sspd/table',
      name: 'Territorial',
      component: () => import('./views/EspecificReports/SSPD/Territorio'),
      meta: {
        requiresAuth: true
      }
    },

    // USAID
    {
      path: '/usaid/tables',
      name: 'Tablas',
      component: () => import('./views/EspecificReports/USAID/Tables'),
      meta: {
        requiresAuth: true
      }
    },

    // SAC
    {
      path: '/sac/tables',
      name: 'Tablas',
      component: () => import('./views/EspecificReports/SAC/Tables'),
      meta: {
        requiresAuth: true
      }
    },

    // Reporte dash
  {
    path: '/scrum/dash',
    name: 'Reporte Dash',
    component: () => import('./views/EspecificReports/SCRUM/DashScrum'),
    meta: {
      requiresAuth: true
    }
  },
  // Reporte IK
{
  path: '/scrum/ik',
  name: 'Reporte ik',
  component: () => import('./views/EspecificReports/SCRUM/ReporteScrum'),
  meta: {
    requiresAuth: true
  }
},
  // Reporte Semanal
  {
    path: '/scrum/semanal',
    name: 'Reporte Semanal',
    component: () => import('./views/EspecificReports/SCRUM/ReporteSemanal'),
    meta: {
      requiresAuth: true
    }
  },

  // Reporte Persona
  {
    path: '/scrum/persona',
    name: 'Reporte Persona',
    component: () => import('./views/EspecificReports/SCRUM/ReportePersona'),
    meta: {
      requiresAuth: true
    }
  },

  // Reporte Planeación
  {
    path: '/scrum/planeacion',
    name: 'Reporte Planeacion',
    component: () => import('./views/EspecificReports/SCRUM/ReportePlaneacion'),
    meta: {
      requiresAuth: true
    }
  },

  // Reporte Proyecto
  {
    path: '/scrum/proyecto',
    name: 'Reporte Proyectos',
    component: () => import('./views/EspecificReports/SCRUM/ReporteProyectos'),
    meta: {
      requiresAuth: true
    }
  },
  // Reporte Actividad
  {
    path: '/scrum/actividad',
    name: 'Reporte Actividad',
    component: () => import('./views/EspecificReports/SCRUM/ReporteActividad'),
    meta: {
      requiresAuth: true
    }
  },
  // DNP GLP EMPRESA
  {
    path: '/dnp_gas/empresa',
    name: 'Reporte Empresa',
    component: () => import('./views/EspecificReports/DNPGLP/ReportesEmpresas'),
    meta: {
      requiresAuth: true
    }
  },




    // COVID Reporte Médico
    {
      path: '/covid/reporte',
      name: 'Reporte Covid',
      component: () => import('./views/EspecificReports/Covid/ReporteCovid'),
      meta: {
        requiresAuth: true
      }
    },

    // COVID Ficha Personal
    {
      path: '/covid/ficha_personal/:cc',
      name: 'FichaPersonal',
      component: () => import('./views/EspecificReports/Covid/FichaPersonal'),
      meta: {
        requiresAuth: true
      }
    },

    // COVID Dash Principal
    {
      path: '/covid/dash/',
      name: 'DashCovid',
      component: () => import('./views/EspecificReports/Covid/DashCovid'),
      meta: {
        requiresAuth: true
      }
    },

    // COVID Reporte por Proceso
    {
      path: '/covid/reporte_proceso/',
      name: 'Reporte Proceso',
      component: () => import('./views/EspecificReports/Covid/ReporteProceso'),
      meta: {
        requiresAuth: true
      }
    },

    // COVID Reporte Visitante
    {
      path: '/covid/reporte_visitante/',
      name: 'Reporte Visitante',
      component: () => import('./views/EspecificReports/Covid/ReporteVisitante'),
      meta: {
        requiresAuth: true
      }
    },

    // COVID Reporte Cliente
    {
      path: '/covid/reporte_cliente/',
      name: 'Reporte Cliente',
      component: () => import('./views/EspecificReports/Covid/ReporteCliente'),
      meta: {
        requiresAuth: true
      }
    },

    // COVID Reporte Cliente
    {
      path: '/covid/reporte_observacion/',
      name: 'Reporte Observacion',
      component: () => import('./views/EspecificReports/Covid/ReporteObservacion'),
      meta: {
        requiresAuth: true
      }
    },

    // COVID Reporte Post Encuesta
    {
      // path: '/covid/post_encuesta/:sid&:saveid',
      path: '/covid/post_encuesta/:token',
      name: 'Reporte Post Encuesta',
      component: () => import('./views/EspecificReports/Covid/ReportePostEncuesta'),
      meta: {
        requiresAuth: false
      }

    },
    {
      path: '/covid/mapa',
      name: 'MapaCovid',
      component: () => import('./views/EspecificReports/Covid/MapaCovid'),
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/covid/mapa_general',
      name: 'Mapa General',
      component: () => import('./views/EspecificReports/Covid/MapaGeneral'),
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/covid/mapa_secciones',
      name: 'Mapa Secciones',
      component: () => import('./views/EspecificReports/Covid/MapaSecciones'),
      meta: {
        requiresAuth: true
      }

    },
    {
      path: '/covid/reporte_inicial/',
      name: 'Reporte Inicial',
      component: () => import('./views/EspecificReports/Covid/ReporteInicial'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/mapa_distancias',
      name: 'Mapa Distancias',
      component: () => import('./views/GeneralReports/MapaDistancia'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/descarga/',
      name: 'Descargar Tabla',
      component: () => import('./views/GeneralReports/DescargarTabla'),
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/cobertura/',
      name: 'Cobertura',
      component: () => import('./views/EspecificReports/Rosario/Cobertura'),
      meta: {
        requiresAuth: true
      }
    },

    /** Para los demas casos */
    {
      path: '*',
      name: 'Everyone Else',
      redirect: {
        name: 'Proyectos'
      }
    }

  ]
})

router.beforeEach((to, from, next) => {
  // revisar sessionStorage
  let t = sessionStorage.getItem('IK')
  if (t != null) store.commit('auth_success', t)

  // let usrPaths = store.state.routes
  // console.log('route changed')
  // if (usrPaths === null) {
  //   console.log('do nothing')
  // } else if (usrPaths.includes(to.path)) {
  //   console.log('Path include')
  // } else {
  //   console.log('Path not include')
  // }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.dispatch('refreshSession')
      .then(() => next())
      .catch(() => next('/'))
      // .then(function (resp) {
      //   next()
      // })
      // .catch(() => next('/'))
  } else {
    next()
  }
})

export default router
